import { render, staticRenderFns } from "./changePwDialog.vue?vue&type=template&id=50436b24&scoped=true"
import script from "./changePwDialog.vue?vue&type=script&lang=js"
export * from "./changePwDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50436b24",
  null
  
)

export default component.exports